module.exports = __webpack_public_path__ + "media/game-win-1.ae0f34df.wav";